<template>
  <div class="main-box fx-c">
    <div class="header fx-none">
      <div class="fx-full">
        案例站在线查询
        <!-- <span class="cur" v-for="(item,index) in tabList" :class="activeTab==index?'activeClass':''" :key="index" @click="clickTab(item.value)">{{item.label}}</span> -->
      </div>
      <div class="fx-none">
        <img class="img" src="@/assets/img/12.png" />
        <el-dropdown>
          <span class="el-dropdown-link">
            {{$store.state.userInfo.bloginName}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="clickLogout">登出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="body fx-full">
      <caseStation />
      <!-- <DataAssistant v-if="activeTab==0" />
      <operations v-if="activeTab==1" /> -->
    </div>
  </div>
</template>

<script>
import { removeToken } from '@/base/cookie'
// import operations from '../OperationsAssistant/index'
// import DataAssistant from '../DataAssistant/index'
import caseStation from './caseStation.vue'
export default {
  components: {
    caseStation
    // operations,
    // DataAssistant
  },
  data() {
    return {
      activeTab: 0,
      caseStation
      // tabList: [{ label: 'WA数据助手', value: 0 }, { label: '外贸版运营小助手', value: 1 }]
    }
  },
  mounted() {

  },
  methods: {
    clickTab(val) {
      this.activeTab = val
    },
    clickLogout() {
      this.$store.commit('SETUSERINFO', {})
      removeToken()
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.main-box {
  height: 100%;
  .body {
    height: calc(100% - 66px);
    overflow: auto;
  }
}
.header {
  background: rgb(0, 21, 41);
  color: white;
  padding: 20px 25px;
  display: flex;
  .img {
    border-radius: 15px;
    height: 26px;
    margin-right: 10px;
    vertical-align: bottom;
  }
}
.el-dropdown {
  margin-bottom: 4px;
}
.el-dropdown-link {
  color: #fff;
}
.cur {
  cursor: pointer;
}
.cur + .cur {
  margin-left: 30px;
}
.activeClass {
  color: #409eff;
}
</style>
